// MODAL OPEN SCRIPT
// ________________________________________________________________
document.addEventListener("click", function (event) {
  // Проверяем, была ли нажата кнопка с id "openSizeChartBtn"
  if (event.target && event.target.id === "openSizeChartBtn") {
    const modal = document.getElementById("sizeChartModal");

    if (modal) {
      // Если модалка уже открыта, закрываем её
      if (modal.style.display === "block") {
        console.log("Size chart modal is already open. Closing...");
        modal.style.display = "none";
      }

      // Затем открываем её заново
      console.log("Opening size chart modal...");
      modal.style.display = "block";
    } else {
      console.error("Size chart modal not found!");
    }
  }
});

// MODAL CLOSE SCRIPT
// ________________________________________________________________
document.addEventListener("click", function (event) {
  var modal = document.getElementById("sizeChartModal");
  if (!modal) return;

  // Если нажали кнопку закрытия модального окна
  if (event.target && event.target.dataset.closeModal !== undefined) {
    modal.style.display = "none";
    console.log("Size chart modal closed via button.");
  }

  // Если кликнули за пределами модального окна
  if (event.target === modal) {
    modal.style.display = "none";
    console.log("Size chart modal closed via outside click.");
  }
});

//MODAL SIZE CLOSE WITH QUICK-DRAWER SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  const sizeChartModal = document.getElementById("sizeChartModal");

  if (!sizeChartModal) {
    console.error("Size chart modal not found.");
    return;
  }

  // Функция для закрытия модального окна
  function closeSizeChartModal() {
    if (sizeChartModal.style.display === "block") {
      sizeChartModal.style.display = "none";
      console.log("Size chart modal closed due to quick-buy-drawer removal.");
    }
  }

  // Слушаем удаление элемента quick-buy-drawer
  document.addEventListener("DOMNodeRemoved", function (event) {
    const removedNode = event.target;

    if (removedNode.tagName === "QUICK-BUY-DRAWER") {
      closeSizeChartModal();
    }
  });
});

//MODAL SIZE SWITCH SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  // Получаем элементы
  const toggleSwitch = document.querySelector(".toggle-switch");
  const toggleButton = toggleSwitch.querySelector(".toggle-button");
  const labels = toggleSwitch.querySelectorAll(".toggle-label");

  const feetTable = document.querySelector(".feet-version");
  const cmTable = document.querySelector(".cm-version");

  let isFeet = false; // Начальное состояние

  // Функция переключения
  function toggleUnit() {
    isFeet = !isFeet;

    // Переключаем классы и анимацию кнопки
    toggleSwitch.classList.toggle("active", !isFeet);
    toggleButton.style.transform = isFeet
      ? "translateX(2px)"
      : "translateX(55px)";

    // Обновляем активные метки
    labels.forEach((label) => {
      label.classList.remove("active");
    });
    document
      .querySelector(`[data-unit="${isFeet ? "feet" : "cm"}"]`)
      .classList.add("active");

    // Показываем нужную таблицу
    feetTable.style.display = isFeet ? "block" : "none";
    cmTable.style.display = isFeet ? "none" : "block";

    // Лог состояния (опционально)
    console.log(isFeet ? "Switched to FEET" : "Switched to CM");
  }

  // Обработчик клика
  toggleSwitch.addEventListener("click", toggleUnit);

  // Первоначальная настройка
  toggleUnit(); // Применяем состояние по умолчанию
});
// FREE SHIPPING BAR SCRIPT
// ________________________________________________________________


document.addEventListener("DOMContentLoaded", function () {
  const FREE_SHIPPING_THRESHOLD = 9900;

  /**
   * Запрашивает данные корзины (cart.js) и возвращает Promise с cartData
   */
  function fetchCartData() {
    return fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }
        return response.json();
      })
      .catch((error) => {
        console.error("Error fetching cart data:", error);
        return { items_subtotal_price: 0 };
      });
  }

  /**
   * Обновляет прогресс-бар, исходя из суммы корзины (cartSubtotal в центах)
   */
  function updateProgressBar(cartSubtotal) {
    const shippingBars = document.querySelectorAll(".free-shipping-bar");
    if (!shippingBars.length) return;

    shippingBars.forEach((bar) => {
      const progressBar = bar.querySelector(".progress-bar");
      const freeShippingText = bar.querySelector(".free-shipping-text");
      if (!progressBar || !freeShippingText) return;

      // Ищем или создаём элемент заливки
      let fillEl = progressBar.querySelector(".progress-bar__fill");
      if (!fillEl) {
        fillEl = document.createElement("div");
        fillEl.className = "progress-bar__fill";
        progressBar.appendChild(fillEl);
      }

      // Вычисляем процент (не более 100%)
      const progress = Math.min((cartSubtotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
      fillEl.style.width = `${progress}%`;

      // Обновляем текст
      const difference = FREE_SHIPPING_THRESHOLD - cartSubtotal;
      if (difference > 0) {
        freeShippingText.textContent = `Only $${(difference / 100).toFixed(2)} away from free shipping`;
      } else {
        freeShippingText.textContent = "Congratulations! Free shipping unlocked!";
      }
    });
  }

  /**
   * Обновляет данные корзины и прогресс-бар
   */
  function fetchAndUpdateBar() {
    fetchCartData().then((cartData) => {
      updateProgressBar(cartData.items_subtotal_price);
    });
  }

  // ===========================
  // 1) КЛИК НА "ADD TO CART"
  // ===========================
  document.body.addEventListener("click", function (event) {
    const addToCartButton = event.target.closest('form[action="/cart/add"] button');
    if (addToCartButton) {
      setTimeout(fetchAndUpdateBar, 200);
    }
  });

  // ===========================
  // 2) ОТСЛЕЖИВАНИЕ ИЗМЕНЕНИЙ В CART-DRAWER (НОВЫЙ МЕТОД)
  // ===========================
  const cartDrawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
  if (cartDrawer) {
    const observer = new MutationObserver(fetchAndUpdateBar);
    observer.observe(cartDrawer, { childList: true, subtree: true }); // Теперь отслеживаем всё!
  }

  // ===========================
  // 3) ПЕРВОЕ ОБНОВЛЕНИЕ (ДЛЯ ПУСТОЙ КОРЗИНЫ)
  // ===========================
  setTimeout(fetchAndUpdateBar, 500);
});

// ________________________________________________________________

// PRODUCT COUNT SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  // Делегируем события или (как вариант) вешаем на каждую кнопку
  // Ниже — пример делегирования на весь документ
  document.addEventListener("click", function (event) {
    // Проверяем, кликнули ли именно по кнопке с классом `quantity-btn`
    if (!event.target.classList.contains("quantity-btn")) return;

    const button = event.target;
    // Ищем инпут в контейнере
    const input = button.closest(".quantity-container")?.querySelector(".quantity-input");
    if (!input) return;

    // Текущее значение
    let quantity = parseInt(input.value, 10) || 1;
    // Считываем атрибут max, если он есть
    const maxAttr = input.getAttribute("max");
    const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : Infinity; // Если нет max, считаем, что без ограничений

    // Если нажали кнопку увеличения
    if (button.classList.contains("increase-btn")) {
      // Увеличиваем, но не выходим за maxQuantity
      if (quantity < maxQuantity) {
        quantity++;
      }
    }
    // Если нажали кнопку уменьшения
    else if (button.classList.contains("decrease-btn")) {
      // Не уходим ниже 1
      quantity = Math.max(1, quantity - 1);
    }

    // Устанавливаем новое значение
    input.value = quantity;

    // Триггерим то же событие, что и при нажатии Enter (change)
    // чтобы ваш is="quantity-input" или другой скрипт подхватил
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
});


// ________________________________________________________________

// RECOMENDATIONS-SLIDER SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("recommendations-slider");
  const prevButton = document.querySelector(".slider-prev");
  const nextButton = document.querySelector(".slider-next");

  // Получаем размеры и отступы
  const itemWidth = slider.querySelector(".recommendation-item").offsetWidth; // Ширина элемента
  const gap = parseInt(getComputedStyle(slider).gap) || 0; // Промежуток между элементами
  const step = itemWidth + gap; // Шаг прокрутки = ширина + gap

  let scrollPosition = 0; // Текущая позиция прокрутки

  // Прокрутка вперёд
  nextButton.addEventListener("click", function () {
    scrollPosition += step;
    // Ограничиваем прокрутку правым краем
    if (scrollPosition > slider.scrollWidth - slider.clientWidth) {
      scrollPosition = slider.scrollWidth - slider.clientWidth;
    }
    slider.scrollTo({ left: scrollPosition, behavior: "smooth" });
  });

  // Прокрутка назад
  prevButton.addEventListener("click", function () {
    scrollPosition -= step;
    // Ограничиваем прокрутку левым краем
    if (scrollPosition < 0) {
      scrollPosition = 0;
    }
    slider.scrollTo({ left: scrollPosition, behavior: "smooth" });
  });
});

// ________________________________________________________________

// BUNDLE SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButton = document.getElementById("add-bundle-to-cart");

  if (!addToCartButton) return;

  addToCartButton.addEventListener("click", function () {
    // Список выбранных товаров
    const selectedVariants = [];
    const sizeSelectors = document.querySelectorAll(".bundle-detail__size-selector");

    // Проходим по всем селекторам размеров
    sizeSelectors.forEach((selector) => {
      const selectedOption = selector.options[selector.selectedIndex];
      if (selectedOption && selectedOption.value) {
        selectedVariants.push({
          id: selectedOption.value, // ID варианта
          quantity: 1, // Количество
        });
      }
    });

    // Проверяем, все ли товары имеют выбранный размер
    if (selectedVariants.length !== sizeSelectors.length) {
      alert("Please select sizes for all items in the bundle.");
      return;
    }

    console.log("Selected variants for bundle:", selectedVariants);

    // Отправляем запрос на добавление товаров в корзину
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: selectedVariants }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to add items to cart");
        return response.json();
      })
      .then((data) => {
        console.log("Bundle added to cart:", data);

        // Перенаправляем покупателя на страницу корзины
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error adding bundle to cart:", error);
        alert("An error occurred while adding the bundle to your cart.");
      });
  });
});


// QUICK-BUY SCRIPT
// ________________________________________________________________

document.addEventListener("DOMContentLoaded", function () {
  const quickBuyButtons = document.querySelectorAll(".quick-buy-button");

  quickBuyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = button.getAttribute("data-variant-id");

      if (!variantId) {
        alert("Variant ID not found.");
        return;
      }

      // Add product to cart and redirect to checkout
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((response) => {
          if (response.ok) {
            // Redirect to checkout
            window.location.href = "/checkout";
          } else {
            console.error("Error adding product to cart:", response);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  });
});

// ROLL-TO-UP SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  const scrollToTopButton = document.getElementById("scrollToTop");

  // Показать кнопку при прокрутке вниз
  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      scrollToTopButton.classList.add("visible");
    } else {
      scrollToTopButton.classList.remove("visible");
    }
  });

  // Скролл наверх при нажатии
  scrollToTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});

// FULL-WIDTH SLIDER SCRIPT
// ________________________________________________________________
document.addEventListener("DOMContentLoaded", function () {
  /* ======== ТАБЫ ======== */
  const tabs = document.querySelectorAll(".tag-slider__tab");
  const tabContents = document.querySelectorAll(".tag-slider__tab-content");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Удаляем класс active со всех табов и контентов
      tabs.forEach((t) => t.classList.remove("active"));
      tabContents.forEach((tc) => tc.classList.remove("active"));

      // Добавляем active на текущий таб и соответствующую вкладку
      this.classList.add("active");
      const targetId = this.getAttribute("data-tab-target");
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });

  /* ======== Слайдер (только кнопки на 33%) ======== */
  const sliderWrappers = document.querySelectorAll(".slider-wrapper");

  sliderWrappers.forEach((wrapper) => {
    const track = wrapper.querySelector(".slider-track");
    const btnPrev = wrapper.querySelector(".slider-btn--prev");
    const btnNext = wrapper.querySelector(".slider-btn--next");

    // Текущее "количество процентов", на которое сместили слайдер
    let shiftPercent = 0;

    // "Next": смещаем на +33%
    btnNext?.addEventListener("click", () => {
      shiftPercent += 33;
      track.style.transform = `translateX(-${shiftPercent}%)`;
    });

    // "Prev": смещаем на -33% (но не уходим в минус)
    btnPrev?.addEventListener("click", () => {
      shiftPercent -= 33;
      if (shiftPercent < 0) shiftPercent = 0;
      track.style.transform = `translateX(-${shiftPercent}%)`;
    });
  });
});

// CART OVERLAY SCRIPT
// ________________________________________________________________

document.addEventListener("DOMContentLoaded", function () {
  // Создаём функцию, которая инициализирует оверлей внутри cart-drawer
  function initializeOverlay(cartDrawer) {
    console.log("cart-drawer найден, инициализируем оверлей...");

    // 1. Создаём оверлей
    const overlay = document.createElement("div");
    overlay.className = "cart-drawer-overlay";
    Object.assign(overlay.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 9999,
      opacity: 0,
      pointerEvents: "none",
      transition: "opacity 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    });

    // 2. Создаём индикатор загрузки (спинер)
    const loader = document.createElement("div");
    loader.className = "cart-drawer-loader";
    Object.assign(loader.style, {
      width: "40px",
      height: "40px",
      border: "4px solid rgba(255, 255, 255, 0.3)",
      borderTop: "4px solid white",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    });

    overlay.appendChild(loader);
    cartDrawer.appendChild(overlay);
    console.log("Оверлей со спинером добавлен внутрь cart-drawer.");

    // 3. Функция для показа оверлея на 1.5 секунды
    function showOverlay() {
      overlay.style.opacity = 1;
      overlay.style.pointerEvents = "auto";
      console.log("Оверлей активирован.");

      setTimeout(() => {
        overlay.style.opacity = 0;
        overlay.style.pointerEvents = "none";
        console.log("Оверлей скрыт.");
      }, 1500);
    }

    // 4. Отслеживаем клики на document
    //  - Удаление товара (ссылка с quantity=0)
    //  - Клик по кнопкам +/- (class="quantity-btn")
    document.addEventListener("click", function (event) {
      // Проверка на ссылку удаления
      const removeButton = event.target.closest("a.link");
      if (removeButton && removeButton.href.includes("quantity=0")) {
        console.log("Клик по кнопке удаления товара.");
        showOverlay();
        return;
      }

      // Проверка на кнопки +/- количества
      const quantityBtn = event.target.closest(".quantity-btn");
      if (quantityBtn) {
        console.log("Клик по кнопке изменения количества (±).");
        showOverlay();
        return;
      }
    });

    // 5. Отслеживаем изменения в инпуте с количеством
    //  (если пользователь вручную ввёл число и нажал Enter или ушёл с поля)
    document.addEventListener("change", function (event) {
      if (event.target.matches(".quantity-input")) {
        console.log("Изменение инпута количества товара.");
        showOverlay();
      }
    });

    // 6. Добавляем анимацию спинера в <style>
    const style = document.createElement("style");
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  // Пытаемся найти cart-drawer сразу
  let cartDrawer = document.querySelector("cart-drawer");

  if (cartDrawer) {
    initializeOverlay(cartDrawer);
  } else {
    console.warn("cart-drawer элемент не найден сразу. Ждем появления элемента...");
    // Если cart-drawer не найден, используем MutationObserver для ожидания появления
    const observer = new MutationObserver(function (mutations, observerInstance) {
      cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        console.log("cart-drawer появился, инициализируем оверлей...");
        observerInstance.disconnect();
        initializeOverlay(cartDrawer);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});



// HEADER SCRIPT

document.addEventListener("DOMContentLoaded", function() {
  const header = document.getElementById("shopify-section-sections--23978618782040__header");
  const headerHeight = header.offsetHeight;
  let lastScrollY = window.scrollY || window.pageYOffset;

  // Создаём placeholder, который будет сохранять высоту хедера в потоке документа,
  // чтобы при переходе в fixed не было «подъёма» контента
  const placeholder = document.createElement("div");
  placeholder.style.height = headerHeight + "px";

  window.addEventListener("scroll", function() {
    const currentScrollY = window.scrollY || window.pageYOffset;

    // Если страница прокручена ниже высоты хедера, делаем его фиксированным
    if (currentScrollY > headerHeight) {
      // Если класс fixed ещё не добавлен, добавляем его и вставляем placeholder
      if (!header.classList.contains("fixed")) {
        header.classList.add("fixed");
        header.style.transform = "translateY(0)";
        header.parentNode.insertBefore(placeholder, header);
      }

      // Определяем направление прокрутки:
      // Если скроллим вниз – скрываем хедер,
      // если вверх – возвращаем его в видимую область.
      if (currentScrollY > lastScrollY) {
        header.style.transform = "translateY(-100%)";
      } else {
        header.style.transform = "translateY(0)";
      }
    } else {
      // Если мы вернулись к верхней части страницы – возвращаем изначальное положение хедера
      if (header.classList.contains("fixed")) {
        header.classList.remove("fixed");
        header.style.transform = "translateY(0)";
        if (placeholder.parentNode) {
          placeholder.parentNode.removeChild(placeholder);
        }
      }
    }

    lastScrollY = currentScrollY;
  });
});


// PLACEHOLDER CHANGE SCRIPT


document.addEventListener("DOMContentLoaded", function() {


  // Соответствие: плейсхолдер -> путь к PNG-файлу в assets
  const placeholdersMap = {
    "image-placeholder-1": "//vemeny.com/cdn/shop/t/5/assets/bleach.svg?v=146890412354521954581740592834",
    "image-placeholder-2": "//vemeny.com/cdn/shop/t/5/assets/tumble-dry.svg?v=47932005300329856521740592811",
    "image-placeholder-3": "//vemeny.com/cdn/shop/t/5/assets/iron-low.svg?v=105065610300820059911740592826",
    "image-placeholder-4": "//vemeny.com/cdn/shop/t/5/assets/washing-in-cold-water.svg?v=42199982516107088711740592802",
    "image-placeholder-5": "//vemeny.com/cdn/shop/t/5/assets/leather-articles.svg?v=76870486423295582531740592818"
  };



  // Селектор, где скрипт будет искать плейсхолдеры
  const containers = document.querySelectorAll('.accordion__content .prose');


  containers.forEach((element, index) => {

    let htmlContent = element.innerHTML;

    // Перебираем все плейсхолдеры из словаря
    Object.keys(placeholdersMap).forEach((placeholder) => {
      // Проверим, встречается ли этот плейсхолдер в тексте
      if (htmlContent.includes(placeholder)) {
        console.log(`→ Плейсхолдер "${placeholder}" найден. Заменяем на <img>`);

        // Формируем RegExp для глобальной замены
        const pattern = new RegExp(placeholder, 'g');
        // Подставляем соответствующий путь к картинке
        const imgUrl = placeholdersMap[placeholder];
        
        // Тег <img> (можно изменить стили, alt и пр.)
        const newImgTag = `<img src="${imgUrl}" alt="" style="width:24px; height:24px; vertical-align:middle;">`;
        
        // Заменяем все вхождения placeholder на <img>
        htmlContent = htmlContent.replace(pattern, newImgTag);
      } else {
        console.log(`→ Плейсхолдер "${placeholder}" не найден в тексте.`);
      }
    });

    console.log("Содержимое ПОСЛЕ замены:", htmlContent);

    // Записываем обновлённый HTML обратно
    element.innerHTML = htmlContent;
  });
});



//TEST 

document.addEventListener('DOMContentLoaded', function() {
  // Функция рекурсивного обхода узлов для удаления текстовых узлов с "xw"
  function removeXwTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('xw')) {
      node.remove();
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(removeXwTextNodes);
    }
  }

  // Функция для установки наблюдения за конкретным facet-drawer
  function observeFacetDrawer(facetDrawer) {
    // Сразу удаляем "xw", если уже есть
    removeXwTextNodes(facetDrawer);

    // Создаем наблюдатель за изменениями внутри facet-drawer
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            removeXwTextNodes(node);
          });
        }
      });
    });
    observer.observe(facetDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Если facet-drawer уже присутствует, устанавливаем наблюдение
  let facetDrawer = document.getElementById('facets-drawer');
  if (facetDrawer) {
    observeFacetDrawer(facetDrawer);
  }

  // Если facet-drawer отсутствует или может появиться позже, наблюдаем за body
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Если добавленный элемент сам является facet-drawer
          if (node.id === 'facets-drawer') {
            observeFacetDrawer(node);
          } else {
            // Или если facet-drawer встречается в его потомках
            const fd = node.querySelector('#facets-drawer');
            if (fd) {
              observeFacetDrawer(fd);
            }
          }
        }
      });
    });
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});


//DISPLAY: NONE TO ADDITIONAL ACTIONS IN CART

document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname === "/cart") {
        // Находим все элементы с классом line-item__actions text-subdued
        const elements = document.querySelectorAll(".line-item__actions.text-subdued");
        
        elements.forEach(element => {
            element.style.display = "none";
        });
    }
});
